import { useCallback, useState } from 'react';
import API from '../../../api/axiosInstance';

// Onsite Page 2 status (IGFEMS-634). Server owns the transitions and who validated;
// this hook only calls PATCH /ems/onsite/participants/:id/validation and mirrors the result.
const errorText = (err) =>
  err.response?.data?.message || err.response?.data?.msg || err.message;

const CONFLICT_MESSAGE = 'This registration was already updated from another window. Showing the current status.';

export default function useOnsiteValidation(participantId) {
  const [validation, setValidation] = useState(null);
  const [busy,       setBusy]       = useState(false);
  const [error,      setError]      = useState('');

  const initFromPersonData = useCallback((pd) => {
    setValidation(pd?.onsiteValidation || null);
  }, []);

  // Resolves to { ok, message } so callers can move on, or show the server's reason.
  const run = useCallback(async (action) => {
    setBusy(true);
    setError('');
    try {
      const res = await API.patch(`/ems/onsite/participants/${participantId}/validation`, { action });
      setValidation(res.data?.onsiteValidation || null);
      return { ok: true, message: '' };
    } catch (err) {
      let message = errorText(err);
      // 409 = another tab/device changed the status first → load the real one so the form can follow it.
      if (err.response?.status === 409) {
        try {
          const pRes = await API.get(`/ems/participants/${participantId}`);
          setValidation(pRes.data?.person_data?.onsiteValidation || null);
          message = CONFLICT_MESSAGE;
        } catch { /* keep the server message */ }
      }
      setError(message);
      return { ok: false, message };
    } finally {
      setBusy(false);
    }
  }, [participantId]);

  return {
    status: validation?.status || null,
    validatedByName: validation?.validatedByName || '',
    validatedAt: validation?.validatedAt || null,
    busy,
    error,
    initFromPersonData,
    submit:   () => run('submit'),
    validate: () => run('validate'),
    sendBack: () => run('return'),
  };
}
